/**
 * Every line on the founder's invite page. `{name}`-style variables are filled by `fill`. Investor text is
 * never copy: it arrives as data and is rendered as plain text. British spelling; no dashes as punctuation.
 */
export const FOUNDER_COPY = {
  title: 'Invite to SeedForge',
  invalid: 'This invite link is no longer valid',
  loadError: 'Could not load this invite. Try again.',
  retry: 'Try again',
  headline: '{name} from {firm} wants to keep track of {startup}’s progress',
  headlineNoFirm: '{name} wants to keep track of {startup}’s progress',
  headlineUnverified:
    '{startup} is being followed by an investor who has asked you to join SeedForge',
  unverifiedLabel: 'Name as entered by the investor',
  intro: 'Upload your deck. Share one link. Investors follow your progress.',
  hearsVerified: '{name} hears the day your deck is up and follows your progress from there.',
  hearsUnverified:
    'The investor hears the day your deck is up and follows your progress from there.',
  upload: 'Upload your deck',
  signIn: 'Already on SeedForge? Sign in',
  claimLabel: 'Your startup',
  claimSubmit: 'Join with this startup',
  claimDone: 'Joined. Upload your deck to start the follow for {investor}.',
  claimError: 'We could not join this startup. Try again.',
  claimNoStartup: 'Create your startup on SeedForge first, then come back to this link.',
} as const

export type FounderCopyKey = keyof typeof FOUNDER_COPY

/** The text for a key with its `{variables}` filled. */
export function fill(key: FounderCopyKey, vars: Record<string, string> = {}): string {
  return FOUNDER_COPY[key].replace(/\{(\w+)\}/g, (_, name: string) => vars[name] ?? '')
}
